import { Link } from "react-router-dom";
import { Leaf, TreePine, Recycle, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { MATERIAUX } from "@/data/site";
import { useLocale } from "@/context/LocaleContext";

const ICONS = [Leaf, TreePine, Recycle];

export const MateriauxOrigine = ({ dark = false, className = "", testid = "materiaux-origine" }) => {
  const { t } = useLocale();
  return (
  <Reveal className={className}>
    <div className={`rounded-2xl border p-7 lg:p-9 ${dark ? "border-sand/20 bg-sand/5 text-sand" : "border-sand-dark bg-card"}`} data-testid={testid}>
      <p className={`eyebrow mb-3 ${dark ? "text-sand/60" : ""}`}>{t(MATERIAUX.eyebrow)}</p>
      <h3 className={`font-serif text-2xl leading-tight ${dark ? "" : "text-bark"}`}>{t(MATERIAUX.titre)}</h3>
      <div className="grid sm:grid-cols-3 gap-6 mt-6">
        {MATERIAUX.points.map((p, i) => {
          const Icon = ICONS[i];
          return (
            <div key={p.titre} data-testid={`${testid}-${i}`}>
              <Icon className="w-4 h-4 text-terra mb-2" />
              <p className={`font-serif text-lg ${dark ? "" : "text-bark"}`}>{t(p.titre)}</p>
              <p className={`text-sm leading-relaxed mt-1 ${dark ? "text-sand/70" : "text-fumee"}`}>{t(p.texte)}</p>
            </div>
          );
        })}
      </div>
      <p className={`text-xs leading-relaxed mt-6 ${dark ? "text-sand/50" : "text-fumee/80"}`}>{t(MATERIAUX.reserve)}</p>
    </div>
  </Reveal>
  );
};

export const MateriauxLigne = ({ dark = false, className = "", testid = "materiaux-ligne" }) => {
  const { t } = useLocale();
  return (
  <p className={`flex flex-wrap items-start gap-2 text-sm leading-relaxed ${dark ? "text-sand/70" : "text-fumee"} ${className}`} data-testid={testid}>
    <Leaf className="w-4 h-4 text-terra shrink-0 mt-1" />
    <span>{t(MATERIAUX.court)} <Link to="/faq" className="link-line text-terra whitespace-nowrap" data-testid={`${testid}-lien`}>{t("En savoir plus")} <ArrowRight className="w-3 h-3 inline" /></Link></span>
  </p>
  );
};
